define('shared/initializer/form/adapters/mixins/upsell/ViewModelProvidable',[
    '$',
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/util/registers/DataProvider'
], 
function (
    $,
    RSVP,
    state,
    DataProvider
) {
    'use strict';

    function Ctor() {
        var me = this;
        me.viewModelProviderRegistered = new RSVP.Promise(function(rs){
            me.viewModelProviderRegisterResolve = rs;
        });
        me.viewModel = {
            total: 0,
            sync: function() {
                me.viewModelProviderRegistered.then(function(){
                    me.viewModelProvider.emit('change');
                });
            }
        };
    }

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        if (!me.selectedOffers) {
            return RSVP.resolve();
        }
        // var id = me.$form.attr('id');
        var provider = {
            id:  'UpsellFormSingleton',
            value: function(){
                return me.viewModel;
            }
        };
        me.viewModelProvider = provider;
        DataProvider.instance.register( provider );
        me.viewModelProviderRegisterResolve();
    };

    return Ctor;
});
